import { useSelector } from 'react-redux'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import AspectLandscapeIcon from 'assets/svgr-icons/Aspect_Ratio_Landscape.svg'
import AspectPortraitIcon from 'assets/svgr-icons/Aspect_Ratio_Portrait.svg'
import { ASPECT_RATIO_PER_TYPE } from 'containers/SubSidebar/AiImageContent/consts'
import { IListItemData } from '../ListItem/types'

export const useSettingsItemsData = (): IListItemData[] => {
  const { aspectRatioString } = useSelector(
    projectDataSelectors.defaultDimensions
  )

  const currentIcon =
    aspectRatioString === ASPECT_RATIO_PER_TYPE.portrait
      ? AspectPortraitIcon
      : AspectLandscapeIcon

  return [
    {
      id: 'aspect-ratio',
      icon: currentIcon,
      label: aspectRatioString
    }
  ]
}
